import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/inviteCodePersonal/new.png';
const _withScopeId = n => (_pushScopeId("data-v-164e8c94"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "activity-new",
    src: _imports_0,
    alt: ""
};
const _hoisted_2 = ["src", "onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_t_layout = _resolveComponent("t-layout");
    return (_openBlock(), _createBlock(_component_t_layout, {
        "is-footer-border": false,
        "is-copyright": false,
        lang: _ctx.lang
    }, {
        content: _withCtx(() => [
            _createElementVNode("div", {
                class: _normalizeClass(["wrapper", { eng: _ctx.isEng }])
            }, [
                _createElementVNode("div", {
                    class: _normalizeClass(["title", { eng: _ctx.isEng }])
                }, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.$t('邀请好友赚奖赏')), 1),
                    _createElementVNode("a", {
                        onClick: _cache[0] || (_cache[0] =
                            //@ts-ignore
                            (...args) => (_ctx.goRecordListPage && _ctx.goRecordListPage(...args)))
                    }, _toDisplayString(_ctx.$t('领奖记录')), 1)
                ], 2),
                _createElementVNode("div", {
                    class: _normalizeClass(["activity", { eng: _ctx.isEng }])
                }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entranceList, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                            class: "activity-item",
                            key: item.desc
                        }, [
                            (item.showNewLabel && !_ctx.storageLink[item.link])
                                ? (_openBlock(), _createElementBlock("img", _hoisted_1))
                                : _createCommentVNode("", true),
                            _createElementVNode("img", {
                                class: "activity-pic",
                                resize: "cover",
                                src: item.image,
                                onClick: ($event) => (_ctx.jumpTo(item))
                            }, null, 8, _hoisted_2)
                        ]));
                    }), 128))
                ], 2)
            ], 2)
        ]),
        _: 1
    }, 8, ["lang"]));
}
